import {Component, OnInit, OnDestroy, Input, Inject} from '@angular/core';
import {IMqttMessage, MqttService as MqttService2} from "ngx-mqtt";
import {
  MqttService,
} from '../../../../mqtt.service';
import * as fromDevices from '../../../../../home/devices/store';
import {kerberosConfig} from "../../../../../../environments/environment";
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Component({
  selector: "MqttStream",
  templateUrl: './mqttstream.component.html',
  styleUrls: ['./mqttstream.component.scss'],
})
export class MqttStream implements OnInit, OnDestroy  {

  @Input() deviceKey: string;
  @Input() cloudKey: string;
  @Input() changeStatus: any;
  @Input() encrypted: boolean = false;
  @Input() profile: any = null;

  public status: string = 'pending';
  public livestream;
  public liveStreamObservable;
  public liveLegacyStreamObservable;
  public pollingObservables: Array<any> = [];
  public livestreamStarted: boolean = false;
  public timer: any;
  public timerSubscription: any = null;

  public eventsSubscription: Subscription;
  public events$: any;
  public events: any;

  constructor(
    private store: Store<fromDevices.State>,
    @Inject('mqttNew') private _mqttService: MqttService2,
    @Inject('mqttLegacy') private _mqttLegacyService: MqttService2,
    private mqttService: MqttService) {}

  ngOnInit(){
    this.updateStatus('pending');
    const cloudKey = this.cloudKey;
    const deviceKey = this.deviceKey;

    this.publishRequestMQTTLiveStream(cloudKey, deviceKey, this.profile);
    this.subscribeToMQTTLiveStream(cloudKey, deviceKey);
  }

  updateStatus(status) {
    this.status = status;
    if(this.changeStatus){
      this.changeStatus(status);
    }
  }

  subscribeToMQTTLiveStream(cloudKey, deviceKey) {
    this.events$ = this.store.select(fromDevices.getEventsFromDevice(this.deviceKey));
    this.eventsSubscription = this.events$.subscribe((event) => {
      if (event && event.action === 'receive-sd-stream' && event.value && event.value.image) {
        const image = event.value.image.toString();
        this.livestream = image;
        this.updateStatus('started');
      }
    });
  }

  publishRequestMQTTLiveStream(cloudKey, deviceKey, profile = null) {
    const interval = 2000;
    this.timerSubscription = setInterval(() => {

      // New Method single observable
      // We should get rid of the legacy methods as mentioned below.
      const topic = "kerberos/agent/" + this.cloudKey;
      const payload = {
        action: "request-sd-stream",
        device_id: this.deviceKey,
        value: {
          timestamp: Math.floor(Date.now() / 1000),
        }
      };
      this.mqttService.publish(topic, payload, this.encrypted, profile)
    }, interval);
  }

  ngOnDestroy(){
    clearInterval(this.timerSubscription)
    if(this.liveStreamObservable) {
      this.liveStreamObservable.unsubscribe();
    }
    if(this.liveLegacyStreamObservable) {
      this.liveLegacyStreamObservable.unsubscribe();
    }
    if(this.eventsSubscription) {
      this.eventsSubscription.unsubscribe();
    }
  }
}
